/**
 * Parallax Gallery — staggered scroll for .c-meet-artists
 *
 * Each [data-parallax-speed] child translates vertically at a different
 * rate, creating a layered depth effect. Only active while the section
 * is in the viewport (IntersectionObserver gates the scroll listener).
 */

function initParallaxGallery() {
  const section = document.querySelector('.c-meet-artists');
  if (!section) return;

  const items = section.querySelectorAll('[data-parallax-speed]');
  if (!items.length) return;

  // Respect reduced-motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let isVisible = false;
  let ticking = false;

  function updatePositions() {
    const rect = section.getBoundingClientRect();
    const sectionCenter = rect.top + rect.height / 2;
    const viewportCenter = window.innerHeight / 2;
    const offset = viewportCenter - sectionCenter;

    items.forEach((item) => {
      const speed = parseFloat(item.dataset.parallaxSpeed) || 0.3;
      const y = offset * speed;
      item.style.setProperty('--parallax-y', `${y}px`);
    });

    ticking = false;
  }

  function onScroll() {
    if (!isVisible || ticking) return;
    ticking = true;
    requestAnimationFrame(updatePositions);
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      isVisible = entry.isIntersecting;
      if (isVisible) onScroll();
    },
    { rootMargin: '100px' }
  );

  observer.observe(section);
  window.addEventListener('scroll', onScroll, { passive: true });
}

document.addEventListener('DOMContentLoaded', initParallaxGallery);
